import { render, staticRenderFns } from "./PromotionInfoPopup.vue?vue&type=template&id=3a6732da&"
import script from "./PromotionInfoPopup.vue?vue&type=script&lang=js&"
export * from "./PromotionInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports